import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import FractionMyData from "./FractionMyData";
import FractionDemoData from "./FractionDemoData";
import FormData from "./FormData";
import HiresMyData from "./HiresMyData";
import HiresDemoData from "./HiresDemoData";
import JobCreated from "./JobCreated";
import { Dropdown } from "react-bootstrap";
import useResponsiveFlags from "../hooks/useResponsiveFlags";
import axios from "../api/axios";
import LoadingGif from "../assests/images/loading.gif";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Alert
} from "@mui/material";
import { Box, Typography } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

export default function RuniSort() {
  const { isDesktop, isDesktopLogin } = useResponsiveFlags();
  const [activeType, setActiveType] = useState("fraction");
  const [activeTab, setActiveTab] = useState("myData");
  const [currentStep, setCurrentStep] = useState(1);
  const [formData, setFormData] = useState({});
  const [isCreated, setIsCreated] = useState(false);
  const [job, setJob] = useState({});
  const [formErrors, setFormErrors] = useState({});
  const [tokenLoading, setTokenLoading] = useState(true);
  const [tokensData, setTokensData] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [disabled, setDisabled] = useState(true);
  const [bulkExpressionFile, setBulkExpressionFile] = useState({});
  const [modalState, setModalState] = useState({
    open: false,
    type: "", // "warning" | "error"
    message: ""
  });
  const [submittingForm, setSubmittingForm] = useState(false);
  const [noValidTokenError, setNoValidTokenError] = useState(false);
  const navigate = useNavigate();

  const resetState = () => {
    setActiveType("fraction");
    setActiveTab("myData");
    setIsCreated(false);
    setCurrentStep(1);
    setFormData({});
    setFormErrors({});
    setJob({});
    setFractionMyData(initialFractionMyData);
    setFractionDemoData(initialFractionDemoData);
    setHiresMyData(initialHiresMyData);
    setHiresDemoData(initialHiresDemoData);
  };
  const initialFractionMyData = {
    signatureMatrixFile: "blood",
    bulkExpressionFile: { id: "", value: "" },
    platform: "none",
    sequenceType: "Whole Transcriptome Sequencing",
    token: { id: "", value: "" },
    runName: "",
  };

  const initialFractionDemoData = {
    bulkExpressionFile: { id: "", value: "" },
    token: { id: "", value: "" },
  };

  const initialHiresMyData = {
    fractionResultFile: { id: "", value: "" },
    bulkExpressionFile: { id: "", value: "" },
    platform: "none",
    token: { id: "", value: "" },
    runName: "",
  };

  const initialHiresDemoData = {
    bulkExpressionFile: { id: "", value: "" },
    fractionResultFile: { id: "", value: "" },
    token: { id: "", value: "" },
    runName: "",
  };
  const [fractionMyData, setFractionMyData] = useState(initialFractionMyData);
  const [fractionDemoData, setFractionDemoData] = useState(
    initialFractionDemoData
  );
  const [hiresMyData, setHiresMyData] = useState(initialHiresMyData);
  const [hiresDemoData, setHiresDemoData] = useState(initialHiresDemoData);

  const openModal = (type, message) => {
    setModalState({
      open: true,
      type,
      message
    });
  };

  const handleClose = (changeCurrentStep = true) => {
    setModalState(prev => ({ ...prev, open: false }));
    if (changeCurrentStep) {
      setSubmittingForm(false);
      setCurrentStep(1);
    }
  };
  const handleTypeClick = (type) => {
    setActiveType(type);
    setActiveTab("myData");
    setIsCreated(false);
    setCurrentStep(1);
  };

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
    setCurrentStep(1);
    setIsCreated(false);
  };

  const handleGoBack = () => {
    setCurrentStep(1);
  };
  const clearFieldError = (fieldName) => {
    setFormErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };

      // Remove the specific field error from the error object
      delete updatedErrors[fieldName];
      return updatedErrors;
    });
  };

  const validateForm = (formData) => {
    const errors = {};
    if (!formData.bulkExpressionFile.id)
      errors.bulkExpressionFile = "Bulk Expression File is Required";
    if (!formData.token.id) errors.token = "Token is Required";

    if (
      formData.formType === "hiresMyData" ||
      formData.formType === "hiresDemoData"
    ) {
      if (!formData.fractionResultFile.id)
        errors.fractionResultFile = "Fraction Result File is Required";
    }

    setFormErrors((prevErrors) => ({
      ...prevErrors,
      ...errors,
    }));
    return Object.keys(errors).length === 0;
  };

  const updateFormData = (newData) => {
    if (activeType === "fraction") {
      if (activeTab === "myData") {
        setFractionMyData((prevState) => {
          const updatedData = { ...prevState };
          if (newData.bulkExpressionFile) {
            updatedData.bulkExpressionFile = newData.bulkExpressionFile;
          }
          if (newData.token) {
            updatedData.token = newData.token;
          }

          Object.keys(newData).forEach((key) => {
            if (key !== "bulkExpressionFile" || key !== "token") {
              updatedData[key] = newData[key];
            }
          });
          return updatedData;
        });
      } else {
        setFractionDemoData((prevState) => {
          const updatedData = { ...prevState };
          if (newData.bulkExpressionFile) {
            updatedData.bulkExpressionFile = newData.bulkExpressionFile;
          }
          if (newData.token) {
            updatedData.token = newData.token;
          }

          Object.keys(newData).forEach((key) => {
            if (key !== "token" || key !== "bulkExpressionFile") {
              updatedData[key] = newData[key];
            }
          });
          return updatedData;
        });
      }
    } else {
      if (activeTab === "myData") {
        setHiresMyData((prevState) => {
          const updatedData = { ...prevState };
          if (newData.bulkExpressionFile) {
            updatedData.bulkExpressionFile = newData.bulkExpressionFile;
          }
          if (newData.token) {
            updatedData.token = newData.token;
          }

          // Merge other fields
          Object.keys(newData).forEach((key) => {
            if (key !== "bulkExpressionFile" || key !== "token") {
              updatedData[key] = newData[key];
            }
          });

          return updatedData;
        });
      } else {
        setHiresDemoData((prevState) => {
          const updatedData = { ...prevState };
          if (newData.bulkExpressionFile) {
            updatedData.bulkExpressionFile = newData.bulkExpressionFile;
          }
          if (newData.token) {
            updatedData.token = newData.token;
          }
          Object.keys(newData).forEach((key) => {
            if (key !== "bulkExpressionFile" || key !== "token") {
              updatedData[key] = newData[key];
            }
          });

          return updatedData;
        });
      }
    }
  };
  const handleSubmit = (data) => {
    const isValid = validateForm(formData);
    if (isValid) {
      setCurrentStep(2);
    }
  };
  const confirmToSubmit = () => {
    setSubmittingForm(true);
    if (activeType === "fraction" && activeTab === "myData") {
      const selectedFile = bulkExpressionFile.find(
        file => file.id === Number(formData.bulkExpressionFile.id)
      );

      if (!selectedFile) {
        openModal("error", "Please select a valid mixture file.");
        return;
      }

      const samplecount = parseInt(selectedFile.samplecount || 0);

      if (samplecount >= 5) {
        createRun();
      }
      else if (samplecount >= 3) {
        openModal(
          "warning",
          `Your mixture file contains ${samplecount} samples.
         We recommend at least 5 samples. Do you want to continue?`
        );
      }
      else {
        openModal(
          "error",
          "Mixture file must contain at least 3 samples."
        );
      }
    } else {
      createRun();
    }
  };

  const createRun = async () => {
    setErrorMessage("");
    setSuccessMessage("");
    const trimmedRunName = (formData.runName || "").trim();
    if (activeType === "fraction" && activeTab === "myData") {
      const selectedFile = bulkExpressionFile.find(
        file => file.id === Number(formData.bulkExpressionFile.id)
      );
      if (!selectedFile) {
        openModal("error", "Invalid mixture file.");
        return;
      }
      const samplecount = parseInt(selectedFile.samplecount || 0);
      if (samplecount < 3) {
        openModal("error", "Mixture file must contain at least 3 samples.");
        return;
      }
    }
    const payload = {
      ...formData,
      runName: trimmedRunName
    };
    axios.post("/api/create-run", payload)
      .then((res) => {
        if (res.data?.success) {
          setIsCreated(true);
          setJob(res.data?.job);
          setSubmittingForm(false);
        } else {
          if (res.data?.message) {
            setErrorMessage(res.data.message);
            setCurrentStep(1);
            setSubmittingForm(false);
          }
        }
      }).catch((res) => {
        setErrorMessage("Error occured while creating the job.");
        setCurrentStep(1);
        setSubmittingForm(false);
      });
  }
  useEffect(() => {
    getBulkExpressionFiles();
  }, []);

  const getBulkExpressionFiles = async () => {
    setBulkExpressionFile({});
    axios
      .get("/api/getfractionsfiles")
      .then((res) => {
        setBulkExpressionFile(res.data?.filesData);
      })
      .catch((res) => {
        setErrorMessage("Failed to fetch user bulk expression file data.");
      });
  };

  useEffect(() => {
    getTokensDetails();
  }, [activeType]);

  useEffect(() => {
    setFormErrors({});
    setFormData({
      signatureMatrixFile: "",
      bulkExpressionFile: { id: "", value: "" },
      fractionResultFile: { id: "", value: "" },
      platform: "",
      sequenceType: "",
      token: { id: "", value: "" },
      runName: "",
      formType: "",
    });

    if (activeType === "fraction") {
      if (activeTab === "myData") {
        setFractionDemoData(initialFractionDemoData);
        setHiresMyData(initialHiresMyData);
        setHiresDemoData(initialHiresDemoData);
      } else {
        setFractionMyData(initialFractionMyData);
        setHiresMyData(initialHiresMyData);
        setHiresDemoData(initialHiresDemoData);
      }
    } else {
      if (activeTab === "myData") {
        setFractionMyData(initialFractionMyData);
        setFractionDemoData(initialFractionDemoData);
        setHiresDemoData(initialHiresDemoData);
      } else {
        setFractionMyData(initialFractionMyData);
        setFractionDemoData(initialFractionDemoData);
        setHiresMyData(initialHiresMyData);
      }
    }
  }, [activeType, activeTab]);

  useEffect(() => {
    setFormData((prevFormData) => {
      let clearedData = {
        signatureMatrixFile: "",
        bulkExpressionFile: { id: "", value: "" },
        fractionResultFile: { id: "", value: "" },
        platform: "",
        sequenceType: "",
        token: { id: "", value: "" },
        runName: "",
      };

      if (activeType === "fraction") {
        if (activeTab === "myData") {
          return {
            ...clearedData,
            ...fractionMyData,
            formType: "fractionMyData",
          };
        } else {
          return {
            ...clearedData,
            ...fractionDemoData,
            formType: "fractionDemoData",
          };
        }
      } else {
        if (activeTab === "myData") {
          return {
            ...clearedData,
            ...hiresMyData,
            formType: "hiresMyData",
          };
        } else {
          return {
            ...clearedData,
            ...hiresDemoData,
            formType: "hiresDemoData",
          };
        }
      }
    });
  }, [fractionMyData, fractionDemoData, hiresMyData, hiresDemoData]);

  const getTokensDetails = async () => {
    setTokenLoading(true);
    setTokensData({});
    setDisabled(true);
    axios
      .post("/api/get-isort-tokens", {
        type: activeType,
      })
      .then((res) => {
        setTokensData(res.data.tokensData);
        if (res.data?.tokensData?.length === 0) {
          setNoValidTokenError(true);
        } else {
          setDisabled(false);
        }
        setTokenLoading(false);
      })
      .catch((res) => {
        setErrorMessage("Failed to fetch tokens data.");
        setTokenLoading(false);
      });
  };

  return (
    <>
      <div
        style={{
          marginLeft: isDesktop ? "300px" : "0",
          paddingTop: isDesktop ? "" : "101px",
        }}
      >
        <div
          className="d-flex flex-column"
          style={{
            minHeight: isDesktop ? "100vh" : "calc( 100vh - 101px )",
            height: isDesktop ? "100%" : "",
            padding: isDesktop ? "10px 24px 20px 24px" : "6px 4px 10px 4px",
          }}
        >
          <div
            className={`d-flex align-items-center ${!isDesktop ? "justify-content-between" : ""
              }`}
            style={{ paddingRight: "0.8rem" }}
          >
            <p className="screen-title">Run iSort&trade;</p>
            <div className="buttons" data-toggle="buttons-radio">
              <button
                className={`menu-options px-4 ${activeType === "fraction" ? "btn-active" : "btn"
                  }`}
                title="Generate a custom signature matrix file."
                onClick={() => handleTypeClick("fraction")}
              >
                <span>iSort&trade; Fractions</span>
              </button>
              <button
                className={`menu-options px-4 ${activeType === "hires" ? "btn-active" : "btn"
                  }`}
                onClick={() => handleTypeClick("hires")}
                title="Infer the proportions of each cell population of interest present in a set of tissue samples."
                disabled
                style={{ opacity: "0.35", cursor: "not-allowed" }}
              >
                <span>iSort&trade; Hires</span>
              </button>
            </div>

            <div className="dropdown dropdown-buttons">
              <button
                className="btn dropdown-toggle"
                type="button"
                id="optionsMenu"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                {activeType === "fraction" ? (
                  <>iSort&trade; Fractions</>
                ) : (
                  <>iSort&trade; Hires</>
                )}
              </button>
              <ul
                className="dropdown-menu dropdown-menu-end"
                aria-labelledby="optionsMenu"
              >
                <li>
                  <a
                    className="dropdown-item"
                    // href="#"
                    onClick={() => handleTypeClick("fraction")}
                  >
                    iSort&trade; Fractions
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item"
                    style={{ opacity: "0.35", cursor: "not-allowed" }}
                  // href="#"
                  // onClick={() => handleTypeClick("hires")}
                  >
                    iSort&trade; Hires
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <hr
            style={{
              margin: isDesktop ? "0" : "0 0.8rem",
            }}
          />
          <div
            className="d-flex justify-content-between"
            style={{
              margin: "0 0.8rem",
            }}
          >
            {activeType === "fraction" && (
              <div>
                <p className="custom-title" style={{ margin: "16px 0 8px 0" }}>
                  iSort&trade; Fractions
                </p>
                <p className="para-dark-grey pb-1">
                  Quantified immune cell-type composition
                </p>
              </div>
            )}
            {activeType === "hires" && (
              <div>
                <p className="custom-title" style={{ margin: "16px 0 8px 0" }}>
                  iSort&trade; HiRes
                </p>
                <p className="para-dark-grey pb-1">Lorem ipsum abcd cduf</p>
              </div>
            )}
            <div style={{ alignContent: "center" }}>
              {!isDesktopLogin ? (
                <Dropdown>
                  <Dropdown.Toggle variant="light" className="ellipsis-button">
                    &#8942;{/* This is the vertical ellipsis ⋮ */}
                  </Dropdown.Toggle>
                  <Dropdown.Menu align="end">
                    <Dropdown.Item onClick={() => navigate("/uploadfile")}>
                      Upload Data
                    </Dropdown.Item>
                    <Dropdown.Item onClick={() => navigate("/tutorials")}>
                      View Tutorial
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>
              ) : (
                <>
                  <button
                    className="cancel-btn menu-options"
                    onClick={() => navigate("/uploadfile")}
                  >
                    Upload Data
                  </button>
                  <button
                    className="cancel-btn menu-options"
                    style={{ marginRight: "0" }}
                    onClick={() => navigate("/tutorials")}
                  >
                    View Tutorial
                  </button>
                </>
              )}
            </div>
          </div>
          {errorMessage && (
            <Alert
              severity="error"
              onClose={() => setErrorMessage("")}
              sx={{ mb: 2, mx: isDesktop ? 0 : "0.8rem" }}
            >
              {errorMessage}
            </Alert>
          )}
          {successMessage && (
            <Alert
              severity="success"
              onClose={() => setSuccessMessage("")}
              sx={{ mb: 2, mx: isDesktop ? 0 : "0.8rem" }}
            >
              {successMessage}
            </Alert>
          )}
          {noValidTokenError &&
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1.5,
                padding: "10px 14px",
                borderRadius: "8px",
                backgroundColor: "#fdecea", // similar to MUI error bg
                color: "#d32f2f", // MUI error color
                border: "1px solid #f5c2c7",
                margin: isDesktop ? "0 0 1rem" : "0 0.8rem 1rem",
              }}
            >
              <ErrorOutlineIcon fontSize="small" />

              <Typography variant="body2">
                You don't have any valid token available. You can not run iSort&trade; Fractions. If you find this info wrong,
                please{" "}
                <span
                  onClick={() => navigate("/contact")}
                  style={{ color: "#d32f2f", fontWeight: 500, cursor: "pointer", textDecoration: "underline"}}
                >
                  Contact Us
                </span>.
              </Typography>
            </Box>

          }

          <div
            className="form-container flex-grow-1 d-flex justify-content-between flex-column"
            style={{
              margin: isDesktop ? "" : "0 0.8rem",
            }}
          >
            {/* Top Section that contains My data and demo data button */}
            {tokenLoading ? (
              <div className="text-center mt-5">
                <img src={LoadingGif} alt="loading..." width="150px" />
              </div>
            ) : (<>
              <div
                style={{
                  padding: "2px 26px 0",
                  display: "flex",
                  borderBottom: "1px solid #EEEEEE",
                }}
              >
                <button
                  className={`form-label tab mb-0 ${activeTab === "myData" ? "active" : ""
                    }`}
                  onClick={() => handleTabClick("myData")}
                >
                  My Data
                </button>
                <button
                  className={`form-label tab mb-0 ${activeTab === "demoData" ? "active" : ""
                    }`}
                  onClick={() => handleTabClick("demoData")}
                >
                  Demo Data
                </button>
              </div>
              {/* middle section that contains form*/}
              {(currentStep === 1 || (currentStep === 2 && !isCreated)) && (
                <div className="flex-grow-1">
                  {currentStep === 1 &&
                    activeType === "fraction" &&
                    activeTab === "myData" && (
                      <div>
                        <FractionMyData
                          formData={fractionMyData}
                          updateFormData={updateFormData}
                          errors={formErrors}
                          disabled={disabled}
                          tokens={tokensData}
                          clearFieldError={(fieldName) =>
                            clearFieldError(fieldName)
                          }
                          bulkExpressionFile={bulkExpressionFile}
                        />
                      </div>
                    )}
                  {currentStep === 1 &&
                    activeType === "fraction" &&
                    activeTab === "demoData" && (
                      <div>
                        <FractionDemoData
                          formData={fractionDemoData}
                          updateFormData={updateFormData}
                          errors={formErrors}
                          disabled={disabled}
                          tokens={tokensData}
                          clearFieldError={(fieldName) =>
                            clearFieldError(fieldName)
                          }
                        />
                      </div>
                    )}
                  {currentStep === 1 &&
                    activeType === "hires" &&
                    activeTab === "myData" && (
                      <div>
                        <HiresMyData
                          formData={hiresMyData}
                          updateFormData={updateFormData}
                          errors={formErrors}
                          disabled={disabled}
                          clearFieldError={(fieldName) =>
                            clearFieldError(fieldName)
                          }
                        />
                      </div>
                    )}
                  {currentStep === 1 &&
                    activeType === "hires" &&
                    activeTab === "demoData" && (
                      <div>
                        <HiresDemoData
                          formData={hiresDemoData}
                          updateFormData={updateFormData}
                          errors={formErrors}
                          disabled={disabled}
                          clearFieldError={(fieldName) =>
                            clearFieldError(fieldName)
                          }
                        />
                      </div>
                    )}

                  {currentStep === 2 && !isCreated && (
                    <div>
                      <FormData data={formData} />
                    </div>
                  )}
                </div>
              )}

              {/* Buttons Div */}
              {(currentStep === 1 || (currentStep === 2 && !isCreated)) && (
                <div
                  className={`${currentStep === 1
                    ? "d-flex justify-content-end"
                    : "d-flex justify-content-between"
                    } flex-column flex-sm-row ps-3 ps-lg-4 pe-3 pe-lg-4`}
                  style={{
                    paddingTop: "22px ",
                    paddingBottom: "19px",
                    borderTop: "1px solid #EEEEEE",
                  }}
                >
                  {currentStep === 2 && (
                    <button
                      type="button"
                      onClick={handleGoBack}
                      style={{ padding: "10px 97.31px", marginRight: "0" }}
                      className="cancel-btn mb-4 mb-sm-0"
                    >
                      Back
                    </button>
                  )}
                  <button
                    type="submit"
                    onClick={
                      currentStep === 1
                        ? handleSubmit
                        : currentStep === 2
                          ? confirmToSubmit
                          : ""
                    }
                    disabled={disabled || submittingForm}
                    className="continue-btn"
                  >
                    {submittingForm ? "Submitting..." : (
                      <>
                        {currentStep === 1 ? "Continue" : "Create Job"} &nbsp; &rarr;
                      </>
                    )}
                  </button>
                </div>
              )}

              {isCreated && <JobCreated data={job} resetState={resetState} />}
            </>)}
          </div>
        </div>
      </div>
      <Dialog
        open={modalState.open}
        onClose={handleClose}
        disableEscapeKeyDown={modalState.type === "error"}
      >
        <DialogTitle>
          {modalState.type === "warning" ? "Warning" : "Error"}
        </DialogTitle>

        <DialogContent>
          <DialogContentText>
            {modalState.message}
          </DialogContentText>
        </DialogContent>

        <DialogActions>

          {/* Continue button only for warning */}
          {modalState.type === "warning" && (
            <Button
              variant="contained"
              color="warning"
              onClick={() => {
                handleClose(false);
                createRun();
              }}
            >
              Continue
            </Button>
          )}

          <Button
            variant="outlined"
            color={modalState.type === "warning" ? "secondary" : "error"}
            onClick={handleClose}
          >
            {modalState.type === "warning" ? "Cancel" : "Close"}
          </Button>

        </DialogActions>
      </Dialog>
    </>
  );
}
